import { render } from "./view-purchase-order.vue?vue&type=template&id=ab8ad8fe&scoped=true"
import script from "./view-purchase-order.vue?vue&type=script&lang=js"
export * from "./view-purchase-order.vue?vue&type=script&lang=js"

import "./view-purchase-order.vue?vue&type=style&index=0&id=ab8ad8fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8ad8fe"]])

export default __exports__